module.exports = __webpack_public_path__ + "img/zuoh-banner.7ddb3881.png";